import dagre, { Node } from 'dagre'
import { Edge } from 'reactflow'

export const getLayoutedElements = (
  nodes: Node<any>[],
  edges: Edge<any>[],
  direction = 'TB',
  nodeWidth?: number,
  nodeHeight?: number,
) => {
  const dagreGraph = new dagre.graphlib.Graph()
  dagreGraph.setDefaultEdgeLabel(() => ({}))

  const isHorizontal = direction === 'LR'
  dagreGraph.setGraph({
    rankdir: direction,
    ranksep: 150,
  })

  for (const node of nodes) {
    if (node && nodeWidth && nodeHeight) {
      // Set the width and height of the dagre node to match the custom node
      node.width = nodeWidth
      node.height = nodeHeight

      dagreGraph.setNode(node.id, {
        width: nodeWidth,
        height: nodeHeight,
      })
    } else {
      return { nodes, edges }
    }
  }

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target)
  })

  dagre.layout(dagreGraph)

  nodes.forEach((node) => {
    const nodeWithPosition = dagreGraph.node(node.id)
    node.targetPosition = isHorizontal ? 'left' : 'top'
    node.sourcePosition = isHorizontal ? 'right' : 'bottom'

    node.position = {
      x: nodeWithPosition.x,
      y: nodeWithPosition.y,
    }

    // All custom nodes must follow similar style
    node.style = {
      border: 'none',
      padding: 0,
      width: node.width,
      height: node.height,
      borderRadius: 8,
    }

    return node
  })

  return { nodes, edges }
}
